import React from "react";
import { Alert, Box, CircularProgress, Typography, useTheme } from "@mui/material";

const DashboardV2Template = ({
  title,
  description,
  loading = false,
  error = null,
  isEmpty = false,
  emptyMessage = "No data available for the selected filters",
  children,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, px: 1, pt: 1 }}>
      {(title || description) && (
        <Box sx={{ px: 0.5 }}>
          {title && (
            <Typography variant="h6" fontWeight={700} color={theme.palette.text.primary}>
              {title}
            </Typography>
          )}
          {description && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {description}
            </Typography>
          )}
        </Box>
      )}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress />
        </Box>
      ) : null}

      {!loading && error ? (
        <Alert severity="error" sx={{ mx: 0.5 }}>
          {error}
        </Alert>
      ) : null}

      {!loading && !error && isEmpty ? (
        <Box
          sx={{
            py: 6,
            textAlign: "center",
            bgcolor: theme.palette.background.default,
            borderRadius: "12px",
            border: `1px solid ${theme.palette.primary.border2}`,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {emptyMessage}
          </Typography>
        </Box>
      ) : null}

      {!loading && !error && !isEmpty ? children : null}
    </Box>
  );
};

export default DashboardV2Template;
